import { TouchableOpacity, Text } from "react-native";
import { styles } from "./styles";

interface TestButtonProps {
  onPress: () => void;
  label: string;
  variant: "status" | "print" | "clear";
}

export const TestButton = ({ onPress, label, variant }: TestButtonProps) => {
  const buttonStyle = {
    status: styles.statusButton,
    print: styles.printButton,
    clear: styles.clearButton,
  }[variant];

  return (
    <TouchableOpacity onPress={onPress} style={[styles.button, buttonStyle]}>
      <Text style={styles.buttonText}>{label}</Text>
    </TouchableOpacity>
  );
};
